// noinspection DuplicatedCode

import React, {useEffect, useState} from "react";

import {Colors} from "../../../assets/Colors";
import {fetchGet, fetchPost, fetchPut} from "../../../fetchers";
import {useMutation} from "@tanstack/react-query";
import {DynamicTableExtend} from "../../../components/tablecard/DynamicTable";
import {Card} from "@material-tailwind/react";
import {isRequired, useForm} from "../../../components/isRequired";
import Modal from "@material-tailwind/react/Modal";
import ModalHeader from "@material-tailwind/react/ModalHeader";
import ModalBody from "@material-tailwind/react/ModalBody";
import {HrdInputGenerator} from "../../../components/form/HrdInputGenerator";
import ModalFooter from "@material-tailwind/react/ModalFooter";
import Button from "@material-tailwind/react/Button";
import 'react-toastify/dist/ReactToastify.css';
import {maxPageGlobal} from "../../../assets/config";
import {toast} from "react-toastify";

const MasterUserPCPage = ({}) => {
    let initialState = {
        UserPCID: "",
        UserPCName: "", Status: 1,
    };
    const validations = [(
        {UserPCName}) => isRequired(UserPCName) || {UserPCName: "Nama UserPC wajib diisi"}, ({Status}) => isRequired(Status) || {Status: "Status wajib diisi"},
        ({KelompokID}) => isRequired(KelompokID) || {KelompokID: "Kelompok wajib diisi"}, ({Status}) => isRequired(Status) || {Status: "Kelompok wajib diisi"},
        ({DetailAccountID}) => isRequired(DetailAccountID) || {DetailAccountID: "Detail Account wajib diisi"}, ({Status}) => isRequired(Status) || {Status: "Detail Account wajib diisi"},

    ];
    const [buttonTouched, setButtonTouched] = useState(false);

    const {
        changed,
        values,
        isValid,
        touched,
        clearHandler,
        submitHandler,
        customHandler,
        changeHandler,
        errors,
        editHandler
    } = useForm(initialState, validations);
    const [search, setSearch] = useState("");
    const [dataUpkeep, setdataUpkeep] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [detail, setDetail] = useState({});
    const [count, setCount] = useState(maxPageGlobal);
    const [start, setStart] = useState(0);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(0);
    const [param, setParam] = useState({
        start: start,
        count: count,
        search: "",
    });
    const mutationData = useMutation(param => fetchGet("Master/UserPC", param))
    const mutation = useMutation(formData => fetchPost("Master/UserPC", formData))
    const mutationEdit = useMutation(formData => fetchPut("Master/UserPC", formData))

    const [showModalEdit, setShowModalEdit] = useState(false);

    useEffect(() => {
        toast.info('Loading table!', {
            position: "top-center",
            autoClose: 1000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            theme: "light",
        })

        mutationData.mutate(param, {
            onSuccess: async (data, context) => {
                let calc = data?.count - 1;
                if (calc === 0) {
                    calc = 1;
                }

                if (calc % count === 0) {
                    calc = calc + 1;
                }

                let tempMaxPage = data.data ? Math.ceil(calc / count) : 1;
                setMaxPage(tempMaxPage)
            }
        })
    }, [param]);


    const header = [
        {name: "UserPC ID", key: "UserPCID", modifiers: "Text"},
        {name: "Bisnis Unit", key: "BisnisUnitName", modifiers: "Text"},
        {name: "NIK", key: "NIK", modifiers: "Text"},
        {name: "Karyawan Name", key: "KaryawanName", modifiers: "Text"},
        {name: "Status", key: "Status", modifiers: "Status"},
        {name: "Edit", key: "Edit", modifiers: "Button"},
    ]

    const inputBuilder = [

        {
            type: "text",
            name: "UserPCID",
            title: "UserPC ID",
            handler: changeHandler,
            size: "full",
            required: false,
            disabled: true,
            edit: true
        },
        {
            type: "BisnisUnit",
            name: "BisnisUnitID",
            title: "Bisnis Unit",
            handler: customHandler,
            size: "full",
            required: false,
            disabled: true,
            edit: false
        },
        {
            type: "karyawan",
            name: "NIK",
            title: "NIK",
            handler: customHandler,
            size: "full",
            required: false,
            disabled: true,
            edit: false
        },
        {
            type: "Status",
            name: "Status",
            title: "Status",
            handler: customHandler,
            size: "full",
            required: false,
            disabled: false,
            edit: true

        }
    ]

    const filterData = (event) => {
        const filtered = mutationData.data.filter(({NamaKaryawan}) => NamaKaryawan.toLowerCase().includes(event.target.value.toLowerCase()))
        setdataUpkeep(filtered)
    }

    const ModalOpener = (detail) => {
        setShowModal(!showModal)
        setDetail(detail)
    }


    function handleUpdatePage(newPage) {
        let newStart = newPage * count - count;

        setParam({
            start: newStart,
            count: count,
            search: "",
        })

    }

    function handleUpdateCount(newCount) {
        let calc = count - 1;
        if (calc === 0) {
            calc = 1;
        }
        setParam({
            start: parseInt(newCount === "-1" ? 0 : start),
            count: parseInt(newCount === "-1" ? count : newCount),
            search: search,

        })
        setPage(newCount === "-1" ? 0 : start);
        setStart(newCount === "-1" ? count : newCount);
        setSearch(search);
        setPage(1);
        setCount(newCount === "-1" ? count : newCount);
        setStart(newCount === "-1" ? 0 : start);
        setMaxPage(newCount === "-1" ? 1 : Math.ceil(calc / newCount));

    }

    function handleModal(value) {
        setShowModal(true);
        setShowModalEdit(true);
        editHandler(value)
    }

    return (<div className="md:ml-64">
        <div
            style={{background: Colors.primary}}
            className="pt-14 pb-16 px-3 md:px-8 h-auto"
        >
            <div className="container mx-auto max-w-full">
                <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
            </div>
        </div>
        <div className="px-3 md:px-8 h-auto -mt-32">
            <div className="container mx-auto max-w-full">
                <div className="grid grid-cols-1 px-4">
                    <Card>
                        <div className="flex flex-col items-center content-center ">
                            <DynamicTableExtend data={mutationData.data}
                                                header={header}
                                                menuController={filterData}
                                                Master={true}
                                                currentPage={page}
                                                maxPage={maxPage}
                                                name={"UserPC"}
                                                OnClick={ModalOpener}
                                                updateCount={handleUpdateCount}
                                                count={count}
                                                updatePage={handleUpdatePage}
                                                modal={handleModal}
                            />
                        </div>
                    </Card>
                    <Modal
                        size="lg"
                        active={showModal}
                        toggler={() => {
                            setShowModal(true);
                        }}
                    >
                        <ModalHeader
                            className="mt-20"
                            toggler={() => {
                                setShowModal(false);
                                setShowModalEdit(false);

                                clearHandler();
                            }}
                        >

                            {showModalEdit ? "Edit Data" : "Tambah Data"}
                        </ModalHeader>
                        <ModalBody>
                            <form className="w-full " onSubmit={submitHandler}>
                                {inputBuilder.map(({
                                                       type,
                                                       name,
                                                       title,
                                                       handler,
                                                       modifiers,
                                                       size,
                                                       required,
                                                       disabled,
                                                       edit,
                                                   }, id) => {
                                    if (!edit || showModalEdit) {
                                        return (
                                            <HrdInputGenerator type={type} value={values} name={name} title={title}
                                                               onChange={handler} touched={touched}
                                                               buttonTouched={buttonTouched}
                                                               modifiers={modifiers} size={size}
                                                               required={required} errors={errors}
                                                               disabled={disabled}
                                            />
                                        )
                                    }
                                })}
                            </form>
                        </ModalBody>
                        <ModalFooter>
                            <Button
                                color="red"
                                buttonType="link"
                                onClick={() => {
                                    setShowModal(false);
                                    clearHandler();
                                }}
                                ripple="dark"
                            >
                                Cancel
                            </Button>

                            <Button
                                color={(isValid || (!isValid)) ? "green" : "blueGray"}
                                disabled={mutation.isLoading}
                                onClick={() => {
                                    if (!isValid && changed) {
                                        setButtonTouched(true);
                                    }
                                    let tempIsValid = isValid;
                                    if (!isValid) {
                                    }
                                    if (showModalEdit) {
                                        mutationEdit.mutate(values, {
                                            onSuccess: () => {
                                                setShowModal(false);
                                                setShowModalEdit(false);

                                                toast.info('Loading table!', {
                                                    position: "top-center",
                                                    autoClose: 1000,
                                                    hideProgressBar: true,
                                                    closeOnClick: true,
                                                    pauseOnHover: false,
                                                    draggable: true,
                                                    theme: "light",
                                                })

                                                mutationData.mutate(param)
                                                clearHandler();
                                            }
                                        })
                                    } else {
                                        mutation.mutate(values, {
                                            onSuccess: () => {
                                                setShowModal(false);
                                                setShowModalEdit(false);

                                                toast.info('Loading table!', {
                                                    position: "top-center",
                                                    autoClose: 1000,
                                                    hideProgressBar: true,
                                                    closeOnClick: true,
                                                    pauseOnHover: false,
                                                    draggable: true,
                                                    theme: "light",
                                                })

                                                mutationData.mutate(param)
                                                clearHandler();
                                            }
                                        })
                                    }

                                }}
                                ripple={isValid ? "light" : ""}
                            >
                                {mutation.isLoading ?
                                    <>
                                        <svg aria-hidden="true" role="status"
                                             className="inline mr-3 w-4 h-4 text-white animate-spin"
                                             viewBox="0 0 100 101"
                                             fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                                fill="#E5E7EB"/>
                                            <path
                                                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                                fill="current
                                       Color"/>
                                        </svg>
                                        Loading
                                    </>
                                    :
                                    "Submit"
                                }
                            </Button>
                        </ModalFooter>
                    </Modal>
                </div>

            </div>
        </div>

    </div>);

};

export default MasterUserPCPage;
